<template>
  <div id="app" style="padding: 0px;">
    <!-- <div v-show="!loadWidget" class="progress-container" :style="customerSize"><img :src="currentAppUrl + 'progress.gif'" /></div> -->
    <div v-show="!loadWidget" class="progress-container" :style="customerSize"><p><icon :style="customerTitleColor" name="spinner" spin/></p></div>

    <!-- Outside Frame to scale widget ==================================== -->
    <div v-show="loadWidget" class="widget-container" :style="customerSize">
        <div class="flex-container" :style="customerBorderColor">
          <!-- TITLE =============================== -->
            <div class="top">
              <!-- <h1 :style="customerTitleColor">{{ titlemsg }}</h1> -->
              <h1>{{ titlemsg }}</h1>
            </div>

          <!-- NEWS STORY LIST ===============================  :style="customerHeight" -->
            <div class="ListView">
              <div v-show="wPosts.length < 1" style="text-align: center;"><span>{{searchMsg}}</span></div>
              <ul v-show="wPosts.length > 0">
                <li v-for="(article, index) in wPosts">
                  <a :href="appendTracking(article.articleUrl)" target="blank_">
                  <span :data-id="article.id">
                    <img v-show="article.thumbnailUrl.length > 10" :src="article.thumbnailUrl" alt="" />
                    <div><p>{{ article.title }}</p></div>
                  </span>
                  </a>
                </li>
                <!-- <li>
                  <span data-id="46437">
                    <div><img src="https://cdn.givingcompass.org/wp-content/uploads/2018/02/09125722/lebron--160x90.jpg" alt="" /></div>
                    <h3>What Role Can Community Foundations Play In Achieving the SDGs?</h3>
                  </span>
                </li> -->
              </ul>
            </div>

          <!-- FOOTER BAR =============================== -->
            <div class="bottom">
              <form action="https://givingcompass.org/?type=news" method="get" id="form1" target="_blank">
                <div class="searchInput" :style="customerSearchColors">
                  <input type="hidden" name="news" value="news" />
                  <input type="hidden" name="utm_source" value="widget" />
                  <input class="searchInputField" name="s" value="" placeholder=""/>
                  <button type="submit" class="searchIconBox">
                    <svg id="search-icon" class="search-icon" viewBox="0 0 24 24">
                      <path fill="white" d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
                      <path d="M0 0h24v24H0z" fill="none"/>
                    </svg>
                  </button>
                </div>
              </form>
              <div id="gc_sponsor">Powered by <span class="gc_logo">givingcompass</span></div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'app',
  data () {
    return {
      apiservice: 'https://givingcompass.org',
      currentAppUrl: '',
      wCriteria: {},
      wPosts: [],
      wPreviewCriteria: [],
      getPreviewData: {},
      postsLoading: false,
      loadWidget: false,
      titlemsg: 'Trending News & Resources on Impact Philanthropy',
      searchMsg: 'Searching...',
      customerWidth: '',
      customerHeight: '',
      customerSize: '',
      customerColorBase: '', // #73AD21
      customerBorderColor: '',
      customerSearchColors: '',
      customerTitleColor: ''
    }
  },
  methods: {
    appendTracking (url) {
      const q = this.$route.query;

      const params = Object.keys(q).map((key) => {
        if (!key) { return; }
        key = key.toLowerCase();
        if (key.startsWith('utm')) {
          return key + '=' + q[key];
        }
      })
      .filter(Boolean)
      .join('&');

      if (params && params.length > 0) {
         return url + '?' + params;
      }

      return url;
    },

    getCustomerColors (selectedColor, selectedWidth, selectedHeight) {
      this.customerColorBase = selectedColor
      this.customerBorderColor = 'border: 3px solid ' + selectedColor + ';'
      this.customerSearchColors = 'background-color: ' + selectedColor + ';'
      this.customerWidth = 'width: ' + selectedWidth + 'px;'
      this.customerHeight = 'height: ' + selectedHeight + 'px;'
      this.customerTitleColor = 'color: ' + selectedColor + ';'
      this.customerSize = '.ListView::-webkit-scrollbar-thumb {}; width: ' + selectedWidth + 'px; height: ' + selectedHeight + 'px;'
    },

    extractFromURL (urlString, firstkey, secondkey) {
      // 58,Environment,40,Beyond Giving,23,What Ever
      let array = decodeURIComponent(urlString)
      array = array.split(',')
      let newarray = []
      let items = {}
      let ii = 0
      for (let i = 0; i < array.length-1; i++) {
        if ((i % 2) !== 1 || i === 0) { // is even number or 0
          newarray[ii] = JSON.parse('{"' + firstkey + '":"' + array[i] + '","' + secondkey + '":"' + array[i+1] + '"}')
          ii++
        }
      }
      items = newarray
      return items
    },

    // ----- https://localhost/wp-json/wp/v2/pages
    getWPposts () {
      // https://dev.givingcompass.org/wp-json/gcWidget/v1/config?key=8e375058cee249858b42f72a07ee953efecf38f7e6ed69babde665636a0bec91
      // 'a37bfc97880e732eef6743a1a87c9b29ae1e5777e31b22d9c87cd828fa390751'
      // '8e375058cee249858b42f72a07ee953efecf38f7e6ed69babde665636a0bec91'
      let key = this.$route.query.key
      if (key) {
        if (key === 'preview') {
          // ----- Receive urlencoded GET string and convert to object.
          // ----- localhost:8082?key=preview&categories=0,All%20Categories,&regions=0,All%20Regions,&types=all_types,All%20Types,&width=340&height=540&brandColor=#98DCBA&pageSize=5&dataItems=
          this.getPreviewData.categories = this.extractFromURL(this.$route.query.categories, 'id', 'name')
          this.getPreviewData.regions = this.extractFromURL(this.$route.query.regions, 'id', 'name')
          this.getPreviewData.types = this.extractFromURL(this.$route.query.types, 'option', 'label')
          this.getPreviewData.mediaTypes = this.extractFromURL(this.$route.query.mediaTypes, 'option', 'label')
          this.getPreviewData.dataItems = null

          // ----- Check if "All" was selected and send empty array
          let allcategories = _.filter(this.getPreviewData.categories, { 'name': 'All Categories'})
          let allregions = _.filter(this.getPreviewData.regions, { 'name': 'All Regions'})
          let alltypes = _.filter(this.getPreviewData.types, { 'label': 'All Types'})
          let allmediaTypes = _.filter(this.getPreviewData.mediaTypes, { 'label': 'All Media'})
          if (allcategories.length > 0) this.getPreviewData.categories= []
          if (allregions.length > 0) this.getPreviewData.regions = []
          if (alltypes.length > 0) this.getPreviewData.types = []
          if (allmediaTypes.length > 0) this.getPreviewData.mediaTypes = []
          // ----- Not used. For now send empty array
          this.getPreviewData.dataItems = []
          // ----- Color and size information ---------------
          this.getPreviewData.width = this.$route.query.width
          this.getPreviewData.height = this.$route.query.height
          this.getPreviewData.brandColor = this.$route.query.brandColor
          // ----- Number of articles to be returned --------
          this.getPreviewData.pageSize = this.$route.query.pageSize
          // console.log(JSON.stringify(this.getPreviewData))
          // ----- pass size and color to local widget
          // debugger;
          // console.log(this.$route.query.brandColor)
          this.getCustomerColors (this.$route.query.brandColor, this.$route.query.width, this.$route.query.height)
          // ----- Returns posts based on search criteria (posts only) must send full payload including size/color keys.
          axios.post (this.apiservice + '/wp-json/gcWidget/v1/preview', this.getPreviewData)
          .then(response => {
            this.wPosts = response.data
            if (this.wPosts < 1) {
              this.searchMsg = 'No data available for this request. Try different search options.'
            }
            // console.log(this.wPosts)
            this.getCustomerColors (this.wPreviewCriteria.brandColor, this.wPreviewCriteria.width, this.wPreviewCriteria.height)
            // console.log(this.wPosts.brandColor)
            this.loadWidget = true
          })
          .catch(error => {
            console.log(error)
          })
        } else {
          // https://dev.givingcompass.org/wp-json/gcWidget/v1/config?key=67c17d9d6349ccfb53df1f68487c3aefe180de7c0990e3753a700c566c5a421e
          axios.get (this.apiservice + '/wp-json/gcWidget/v1/config?key=' + key)
          .then(response => {
            this.wCriteria = response.data
            this.wCriteria = this.wCriteria.config
            // console.log(this.wCriteria)
            this.getCustomerColors (this.wCriteria.brandColor, this.wCriteria.width, this.wCriteria.height)
            this.loadWidget = true
          })
          .catch(error => {
            console.log(error)
          })
          // ----- Once submitted admin app/api creates a key that links to stored data (posts only)
          axios.get (this.apiservice + '/wp-json/gcWidget/v1/articles?key=' + key)
          .then(response => {
            this.wPosts = response.data
            // console.log(this.wPosts)
          })
          .catch(error => {
            console.log(error)
          })
        }
      }
    }
  },
  onSubmit () {
    console.log('Submit!')
  },
  created () {
    // ----- Switch API source based on environment
    let currentLocation = window.location.origin
    let currentPath = window.location.pathname
    let currentHostname = window.location.hostname
    // ----- Receive custom color from url -- for spinner
    let customerColor = this.$route.hash
    // console.log(customerColor)
    // switch (currentLocation) {
    //   case 'https://dev.givingcompass.org':
    //     this.apiservice = 'https://dev.givingcompass.org'
    //     break
    //   case 'https://qa.givingcompass.org':
    //     this.apiservice = 'https://qa.givingcompass.org'
    //     break
    //   default:
    //     // this.apiservice = 'https://givingcompass.org'
    //     this.apiservice = currentLocation
    // }
    this.apiservice = currentLocation
    // if (currentHostname === 'localhost') {
    //   this.apiservice = 'https://dev.givingcompass.org'
    // }
    if (currentHostname === 'localhost') {
      this.apiservice = 'https://dev.givingcompass.org'
    } else if (currentHostname === 'dev.givingcompass.org') {
      this.apiservice = 'https://dev.givingcompass.org'
    // ----- For testing only. Must turn off in prod ------------
    } else if (currentHostname === 'qa-givingcompass.org') {
      this.apiservice = 'https://qa-givingcompass.org'
    // ----------------------------------------------------------
    } else {
      this.apiservice = 'https://givingcompass.org'
    }
    this.currentAppUrl = currentLocation + currentPath
    // console.log(this.apiservice)
    // ----- Set default size and color -----------
    if (customerColor === '') {
      customerColor = '#73AD21'
    }
    // this.getCustomerColors('#73AD21', '280', '470')
    this.getCustomerColors(customerColor, '280', '470')
    // this.getWConfigs()
    this.getWPposts()
    setTimeout(() => {
      this.loadWidget = true
    }, 3000)
  }
}
</script>

<style lang="scss">
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  font-family: 'Montserrat', -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  font-size: 12px;
  color: #2c3e50;
}

h1 {
  font: 500 18px/1.2 'Avenir', Helvetica, Arial, sans-serif;
  text-align: center;
  /* color: darkgray; */
  color: #535353;
  margin-top: 10px;
  margin-bottom: 20px;
}

/* Font used for list item title */
h3 {
  font: bold 12px/1.2 Helvetica, Verdana, sans-serif;
  color: #535353;
}

/* Reset inherited settings */
* { margin: 0; padding: 0; }

.widget-container {
  border: 0;
  background-color: #fff;
  -webkit-border-radius: 25px;
  -moz-border-radius: 25px;
  border-radius: 25px;
  /* -webkit-box-shadow: 0px 0px 3px 1px rgba(50, 50, 50, 1); */
  /* -moz-box-shadow: 0px 0px 3px 1px rgba(50, 50, 50, 1); */
  /* box-shadow: 0px 0px 3px 1px rgba(50, 50, 50, 1); */
}
.progress-container {
  text-align:center;
  vertical-align:middle;
  margin-top: 150px;
}

.fa-icon {
  width: auto;
  height: 60px; /* or any other relative font sizes */
  color: #73AD21;

  /* You would have to include the following two lines to make this work in Safari */
  max-width: 100%;
  max-height: 100%;
}

.flex-container {
  width: 100%;
  height: 100%;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  border-radius: 8px;
  border: 3px solid #73AD21;
  padding: 10px 15px 15px 15px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
}
.flex-container .top {
  padding-top: 2px;
  padding-bottom: 4px;
  /* border: 1px solid #aaaaaa; */
  flex-basis: content;
}
.flex-container .main {
  border: 1px solid #aaaaaa;
  flex: 3 3 auto;
}
.flex-container .bottom {
  /* border: 1px solid #aaaaaa;*/
  padding: 20px 0px 5px 0px;
  /* flex-grow: 1; */
  flex-basis: content;
}

.flex-container .ListView {
  position: relative;
  text-align: left;
  border: 1px solid #EEEEEE;
  /* overflow-y: scroll; */
  overflow-x: hidden;
  /* Smooth momentum scrolling */
  -webkit-overflow-scrolling: touch;
  flex: 2 2 auto;
}

/* ----- To force scrollbar we have to disable it first and then recreate it */
.ListView::-webkit-scrollbar {
  -webkit-appearance: none;
}

.ListView::-webkit-scrollbar:vertical {
  /* width: 11px; */
  width: 10px;
}

.ListView::-webkit-scrollbar:horizontal {
  height: 11px;
}

.ListView::-webkit-scrollbar-thumb {
  border-radius: 8px;
  border: 2px solid white; /* should match background, can't be transparent */
  background-color: rgba(0, 0, 0, .4);
  /* background-color: #73AD21;
  opacity: 0.5; */
}

.ListView::-webkit-scrollbar-track {
  background-color: #fff;
  border-radius: 8px;
}
/* ----- End Scrollbar css ----- */

.ListView ul {
  list-style-type: none;
  width: 100%;
}

.ListView li img {
  height: 40px;
  float: left;
  /* margin on the left side */
  /* margin: 0 20px 0 5px; */
  margin-right: 20px;
}

.ListView li p {
  /* font: 200 12px/1.5 Georgia, Times New Roman, serif; */
  font: bold 12px/1.2 'Montserrat', -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  color: #535353;
}

.ListView li p:hover {
  color: #6BAF30;
}

.ListView li div {
  height: 40px;
  overflow: hidden;
}

.ListView li a:hover {
  text-decoration: none;
  color: #6BAF30;
  /* opacity: 1.0; */
  cursor: pointer;
}

.ListView li {
  height: 70px;
  padding-left: 5px;
  padding-top: 15px;
  padding-bottom: 15px;
  /* padding: 15px 15px 0 0; */
  background: #fafafa;
  opacity: 0.85;
  overflow: hidden;
  white-space: wrap;
  text-overflow: ellipsis;
  /* overflow: auto; */
}

.ListView li:nth-child(odd) {
  /* background: #eee; */
  opacity: 0.85;
}

.ListView li:hover {
  /* background: #ccc; */
  /* background: #eee; */
  color: #6BAF30;
  opacity: 1.0;
  cursor: pointer;
}

.searchInput {
  position: relative;
  width: 100%;
  height: 28px;
  padding: 2px;
  /* margin-top: 10px; */
  /* margin-bottom: 10px; */
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  /* border: 2px solid #73AD21; */
  background-color: #73AD21;
  cursor: pointer;
}

.searchInputField {
  position: relative;
  float: left;
  width: 85%;
  height: 100%;
  border-radius: 4px 0px 0px 4px;
  border: 0;
  padding-left: 5px;
  font-size: 12px;
  background-color: #FFF;
}

.searchIconBox {
  position: relative;
  float: right;
  width: 15%;
  height: 99.6%;
  /* margin-top: 10px; */
  /* margin-bottom: 10px; */
  /* -webkit-border-radius: 0px 7px 7px 10px;
  -moz-border-radius: 0px 7px 7px 10px;
  border-radius: 0px 7px 7px 0px; */
  border: 0;
  background: transparent;
  cursor: pointer;
}

button:focus {
  outline: none;
}

.searchIconBox svg {
  width: 110%;
  height: 110%;
  -webkit-transform: rotateY(-180deg);
}

#gc_sponsor {
  text-align: center;
  padding:7px 0 0 0;
}

.gc_logo {
  background-image: url(/wp-content/themes/soledad-child/images/logo.svg);
  background-repeat: no-repeat;
  background-size: 100% auto;
  display: inline-block;
  width: 96px;
  height: 15px;
  transition: none;
  vertical-align: middle;
  text-indent: 100%;
  white-space: nowrap;
  overflow: hidden;
}

</style>



// WEBPACK FOOTER //
// src/App.vue